import * as HYPERCUBEJS from '@hypercubejs/hypercubejs';

import {statenodeplayer} from '@/states/nodeplayer.js';

// @TODO
class ScriptSoundAmbiant extends HYPERCUBEJS.Script {

    constructor() {

        super();
    }

    // oninput($entity, $event) {

    //     console.log($event);
    // }

    onstart($entity) {

        // @TODO : only if DeviceSpeaker

        $entity.audio.play();
        $entity.audio.loop = true;

        // setTimeout(() => {

        //     $entity.parent.removechild($entity);
        // }, 4000);
    }

    // /**
    //  * @type {typeof HYPERCUBEJS.Script.prototype.ontick}
    //  */
    // ontick($timeframe, $entity) {

    //     // $entity.translateself([0, 0, -5 * $timeframe / 1000]);

    //     $entity.lookat(statenodeplayer.getstate().translation, [0, 1, 0]);
    // }
}

export {

    ScriptSoundAmbiant
};

export default ScriptSoundAmbiant;
